module.exports = __webpack_public_path__ + "img/BURGER.72cd8d4d.svg";